exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.features[data-v-75a1b838] {\n  margin-top: 20px;\n}\n.additional-tech-description[data-v-75a1b838] {\n  margin-top: 100px;\n}\n.last-tech-description[data-v-75a1b838] {\n  margin-bottom: 250px;\n}\n", ""]);

// exports
